import { Combobox, Option } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { Invoice } from "../../store/Data";
import { useEditorStyles } from "../Styles/Editor";

type InvoiceDropdownProps = {
    invoices: Invoice[];
    setInvoice: (invoice?: Invoice) => void;
    currentInvoice?: Invoice;
};

export const InvoiceDropdown: React.FC<InvoiceDropdownProps> = ({ setInvoice, currentInvoice, invoices }) => {
    // Filters
    const [Filter, setFilter] = React.useState<Invoice[]>([]);
    const [Search, setSearch] = React.useState<string | undefined>();
    // Other
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Initial load
    React.useEffect(() => {
        if (invoices !== undefined) {
            setFilter(invoices);
        }
    }, [invoices]);

    return <Combobox
        className={styles.fluid}
        positioning="above"
        listbox={{
            className: styles.optionContainer,
        }}
        freeform
        placeholder={t('SelectInvoice')}
        onChange={(event) => {
            if (invoices !== undefined) {
                const value = event.target.value.trim();
                const matches = invoices.filter(
                    (c) => (c.invoiceRef !== null && c.invoiceRef.toLowerCase().indexOf(value.toLowerCase()) !== -1)
                );
                setFilter(matches);
                if (value.length && matches.length < 1) {
                    setSearch(value);
                    setInvoice(undefined);
                } else if (value.length && matches.length === 1) {
                    setSearch(value);
                    setInvoice(matches[0]);
                } else {
                    setSearch(undefined);
                    setInvoice(undefined);
                }
            }
        }}
        onOptionSelect={(event, data) => {
            if (data.optionValue && invoices) {
                const matchingOption = invoices.find(c => c.invoiceid === data.optionValue);
                if (matchingOption) {
                    setSearch(undefined);
                    if (matchingOption.invoiceRef !== currentInvoice?.invoiceRef) {
                        setInvoice(matchingOption);
                    }
                    setFilter(invoices);
                } else {
                    setSearch(data.optionText);
                }
            }
        }}
        defaultValue={currentInvoice && currentInvoice.invoiceRef ? currentInvoice.invoiceRef : undefined}
        defaultSelectedOptions={currentInvoice && currentInvoice.invoiceid ? [currentInvoice.invoiceid] : undefined}
    >
        {Search ? (
            <Option key="freeform" text={Search}>
                Search for "{Search}"
            </Option>
        ) : null}
        {Filter.map((p) => (
            <Option key={p.invoiceid} value={p.invoiceid !== null ? p.invoiceid : ""}>{p.invoiceRef !== null ? p.invoiceRef : "-- ? --"}</Option>
        ))}
    </Combobox>;
};